import { Trophy, Percent, Calendar } from 'lucide-react';
import { useCountUp } from '../hooks/useCountUp';

interface Props {
  totalPedidos: number;
  totalTocadas: number;
  taxaSucesso: number;
  diasAtivos: number;
  animar: boolean;
}

interface MiniStatProps {
  icon: typeof Trophy;
  valor: string;
  label: string;
}

function MiniStat({ icon: Icon, valor, label }: MiniStatProps) {
  return (
    <div className="flex flex-col items-center gap-1 bg-white/[0.03] border border-white/[0.05] rounded-2xl px-3 py-2.5 flex-1">
      <Icon size={16} className="text-orange-400" />
      <span className="text-2xl font-bold text-white leading-none">{valor}</span>
      <span className="text-[11px] text-white/40">{label}</span>
    </div>
  );
}

export function PerfilHeroStats({ totalPedidos, totalTocadas, taxaSucesso, diasAtivos, animar }: Props) {
  const pedidosAnimado = useCountUp(totalPedidos, 700);
  const pedidosExibido = animar ? pedidosAnimado : totalPedidos;

  return (
    <div className="flex flex-col sm:flex-row items-center gap-4">
      <div className="flex flex-col items-center justify-center shrink-0">
        <span className="text-5xl font-black text-white leading-none">{pedidosExibido}</span>
        <span className="text-xs text-white/40 mt-1">pedidos</span>
      </div>

      <div className="flex items-stretch gap-2 w-full">
        <MiniStat icon={Trophy} valor={String(totalTocadas)} label="Tocadas" />
        <MiniStat icon={Percent} valor={`${taxaSucesso}%`} label="Sucesso" />
        <MiniStat icon={Calendar} valor={String(diasAtivos)} label="Dias" />
      </div>
    </div>
  );
}
